import { render, staticRenderFns } from "./PatientTabs.vue?vue&type=template&id=38e12e13&scoped=true"
import script from "./PatientTabs.vue?vue&type=script&lang=js"
export * from "./PatientTabs.vue?vue&type=script&lang=js"
import style0 from "./PatientTabs.vue?vue&type=style&index=0&id=38e12e13&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e12e13",
  null
  
)

export default component.exports